import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async"; // ✅ Added for SEO
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { motion } from "framer-motion";
// import Advertisement from "./Advertisement";
import Gallery from "./Gallery";
import Video from "./Video";
import Blogs from "./Blogs";
import Chatbot from "./Chatbot";
import "./home.css";

export default function Home() {
  const images = [
    
    { src: "images/Smaaashday2025.png", link:"https://esmaaash.in/smaaashday/index.html?utm_source=online&utm_medium=esmaaash&utm_campaign=SMAAASH_Day_Banner"},
    { src: "images/Chessmaster_Hyd.jpg", link:"https://esmaaash.in/register/96"},
    { src: "images/Pinkstrike.jpg", link: "https://esmaaash.in/bowlingtournament/index.html" }
  ];

 

  const pastEvents = [
      "/images/smaaaash_chessmaster_hyd.webp",
    "/images/Smaaash_Chessmaster_Manglore.webp",
    "/images/Redzone-2.webp",
    "/images/smaaash-league.webp",
    "/images/Smaaashday-Mumbai.webp",
    "/images/Smaaash_Chessmaster_Noida.webp",
    "/images/Smaaashday-DelhiNCR.webp",
    "/images/Smaaash_Chessmaster_Delhi.webp",
    "/images/Smaaashday-Barnala.webp",
    "/images/Chessmaster-Mumbai.webp",
    "/images/pixel-challenge.webp",
  ];
 
  const sponsorLogos = [
    "/sponsors/Easymytrip.webp",
    "/sponsors/TheIndian.webp",
    "/sponsors/Oaksmith.webp",
    "/sponsors/YESSECURITIES.webp",
    "/sponsors/Mechanix.webp",
    "/sponsors/ABCoffee.webp",
    "/sponsors/Emotorad.webp",
    "/sponsors/FreepressGe.webp",
    "/sponsors/Parle.webp",
    "/sponsors/Radio.webp",
    "/sponsors/Reliance.webp",
  ];

  const responsive = {
    superLargeDesktop: { breakpoint: { max: 4000, min: 1024 }, items: 1 },
    desktop: { breakpoint: { max: 1024, min: 768 }, items: 1 },
    tablet: { breakpoint: { max: 768, min: 464 }, items: 1 },
    mobile: { breakpoint: { max: 464, min: 0 }, items: 1 },
  };

  const [mainSlide, setMainSlide] = useState(0);
  const [pastSlide, setPastSlide] = useState(0);

  

  useEffect(() => {
    const interval = setInterval(() => {
      setPastSlide((prev) => (prev + 1) % pastEvents.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [pastEvents.length]);

  return (
    <div className="esports-bg flex flex-col items-center justify-center p-6 text-white">

      {/* ====== SEO Meta + Canonical ====== */}
      <Helmet>
        <title>Esmaaash | Sports, Gaming & Events in India</title>
        <meta
          name="description"
          content="Join Esmaaash for thrilling events, esports, ambassador programs, and gaming experiences across India. Explore upcoming events, past highlights, and register today."
        />
        <meta
          name="keywords"
          content="Esmaaash, sports events India, gaming tournaments, ambassador club, esports events, bowling championship"
        />
        <link rel="canonical" href="https://esmaaash.in/" />

        {/* Open Graph */}
        <meta property="og:title" content="Esmaaash | Sports, Gaming & Events in India" />
        <meta property="og:description" content="Explore upcoming tournaments, ambassador programs, and gaming events with Esmaaash." />
        <meta property="og:image" content="https://esmaaash.in/images/bowlingt2.jpg" />
        <meta property="og:url" content="https://esmaaash.in/" />
        <meta property="og:type" content="website" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Esmaaash | Sports, Gaming & Events in India" />
        <meta name="twitter:description" content="Gaming, esports, ambassador club & tournaments. Be part of Esmaaash now!" />
        <meta name="twitter:image" content="https://esmaaash.in/images/bowlingt2.jpg" />

        {/* JSON-LD Organization Schema */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Esmaaash",
            "url": "https://esmaaash.in",
            "logo": "https://esmaaash.in/images/logo.png",
            "sameAs": [
              "https://www.facebook.com/esmaaash",
              "https://www.instagram.com/esmaaash",
              "https://twitter.com/esmaaash"
            ]
          }
          `}
        </script>
      </Helmet>


      {/* Main Banner */}
      <div className="w-full flex justify-center">
        <div className="w-full px-0 sm:px-2">
          <Carousel
            responsive={responsive}
            autoPlay
            infinite
            autoPlaySpeed={4000}
            keyBoardControl
            draggable
            arrows={false}
            afterChange={(index) => setMainSlide(index)}
          >
            {images.map((item, index) => {
              const isActive = index === mainSlide;
              return (
                <div key={index} className="w-full overflow-hidden neon-hover" aria-hidden={!isActive}>
                  <a href={item.link} target="_blank" rel="noopener noreferrer" tabIndex={isActive ? 0 : -1}>
                    <div className="w-full bg-black">
                      <img
                        src={item.src}
                        alt={`Slide ${index + 1}`}
                        className="w-full object-contain main-banner"
                        style={{ maxWidth: "100%" }}
                      />
                    </div>
                  </a>
                </div>
              );
            })}
          </Carousel>
        </div>
      </div>

      {/* Video */}
      <Video />

      

 

      {/* Past Events */}
      <motion.h2
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        data-text="PAST EVENTS"
        className="text-3xl font-bold mt-16 mb-6"
      >
        PAST EVENTS
      </motion.h2>

      <div className="section-wrapper past-event-banner relative my-10 min-h-[350px]">
        {pastEvents.map((src, index) => (
          <img
            key={index}
            src={src}
            alt={`Past Event ${index + 1}`}
            className={`past-event-image ${index === pastSlide ? "active neon-hover neon-glow" : ""}`}
            loading="lazy"
          />
        ))}
      </div>

      {/* Sponsors */}
      <motion.h2
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        data-text="OUR PARTNERS"
        className="text-3xl font-bold mt-16 mb-4"
      >
        OUR PARTNERS
      </motion.h2>

      <div className="section-wrapper overflow-hidden my-8 md:my-16 border-t border-gray-600 pt-6">
        <div className="sponsor-rail whitespace-nowrap animate-scroll flex items-center gap-[10px]">
          {[...sponsorLogos, ...sponsorLogos].map((logo, index) => (
            <div key={index} className="inline-block">
              <img src={logo} alt={`Sponsor ${index + 1}`} className="object-contain" loading="lazy" />
            </div>
          ))}
        </div>
      </div>

      {/* Blogs */}
      <div className="section-wrapper">
        <Blogs />
      </div>

      {/* Gallery */}
      <div className="section-wrapper">
        <Gallery />
      </div>

      {/* Chatbot */}
      <Chatbot />
    </div>
  );
}
